import withProps from "recompose/withProps";

export default withProps({ sx: {
		'&.MuiFormControl-root':{
			'& .MuiFormControlLabel-root':{ margin: 0 },
			'& > .MuiFormGroup-root':{
				display: 'flex',
				flexDirection: 'row',
				marginLeft: '-10px',
				width: 'calc(100% + 20px)',
				label: {
					marginLeft: '5px',
					marginBottom: '5px',
					display: 'flex',
					flexDirection: 'column',
					width: '105px',
					overflow: 'hidden',
					padding: '5px',
					border: '1px solid #00000000',
					span:{
						'&.MuiTypography-root':{
							'&, & .title, & .price':{
								width: '100%',
								textAlign: 'center'
							},
							'& .price':{
								color: '#C90808',
							},
						}
					},

					'&.Mui-checked':{
						border: '1px solid #0066CC',
					},
					'& .MuiTypography-root':{
						maxWidth: '100%',
						fontSize: '12px'
					},
					'& .btn':{
						margin: 0,
						marginBottom: '5px',
						'&':{
							borderRadius: 0,
							width: '97px',
							height: '97px',
							padding: '5px',
							border: '1px solid #E2E2E2',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							'span, img':{
								overflow: 'hidden',
								maxWidth: '100%',
								maxHeight: '100%',
								borderRadius: 0,
								padding: 0
							}
						}
					}
				},
			}
		}
	}
})